module.exports = __webpack_public_path__ + "a50ff41d94cc7789dadb96f6e13c3772.woff";